/**
 * Logo "Barilla"
 */
export const BRAND_LOGO_BARILLA = "https://conad.s3.eu-south-1.amazonaws.com/assets/img/brand/logo_barilla.svg";

/**
 * Logo "Mulino Bianco"
 */
export const BRAND_LOGO_MULINO_BIANCO = "https://conad.s3.eu-south-1.amazonaws.com/assets/img/brand/logo_mulino_bianco.svg";